import React, {Component} from 'react';
import * as firebase from 'firebase';
import ReactDom from 'react-dom';
import MetaTags from 'react-meta-tags';
import ReactQuill from 'react-quill';
import {Link} from 'react-router-dom';
import AvatarCropper from "react-avatar-cropper";

export default class AuthorityDashbord extends Component {
  constructor(){
    super();
    this.state = {
      name: '',
      cropperOpen: false,
      img: null,
      croppedImg: "",
      canReload: false
    }
    this.handleSave = this.handleSave.bind(this);
    this.handleChangeName = this.handleChangeName.bind(this);
    this.handleChangeFBGroup = this.handleChangeFBGroup.bind(this);
    this.handleChangeWebSite = this.handleChangeWebSite.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleCrop = this.handleCrop.bind(this);
    this.handleRequestHide = this.handleRequestHide.bind(this);
    this.handleChangeSelfIntroduction = this.handleChangeSelfIntroduction.bind(this);
    this.handlePushTo = this.handlePushTo.bind(this);
    this.handleCancelPushTo = this.handleCancelPushTo.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0,0)
    firebase.auth().onAuthStateChanged((user) => {
      if(user) {
        var userId = firebase.auth().currentUser.uid
        const AuthorityRef = firebase.database().ref('users/').child(userId).child('AuthorityProfile')
        AuthorityRef.update({
          email: user.email ? user.email : null,
          displayName: user.displayName ? user.displayName : null,
          photoURL: user.photoURL ? user.photoURL : null
        })
        AuthorityRef.on('value', snap => {
          this.setState({
            name: snap.val().name,
            FBGroup: snap.val().FBGroup,
            webSite: snap.val().webSite,
            applyForChoice: snap.val().applyForChoice,
            selfIntroduction: snap.val().selfIntroduction,
            userId: userId,
            croppedImg: snap.val().croppedImg ? snap.val().croppedImg : null
          })
        })
      } else {
        window.location = ('/')
      }
    })
  }
  handleFileChange(dataURI) {
    this.setState({
      img: dataURI,
      croppedImg: this.state.croppedImg,
      cropperOpen: true
    });
  }
  handleCrop(dataURI) {
    this.setState({
      cropperOpen: false,
      img: null,
      croppedImg: dataURI
    });
  }
  handleRequestHide() {
    this.setState({
      cropperOpen: false
    });
  }
  handleSave(event) {
    var userId = firebase.auth().currentUser.uid
    const AuthorityRef = firebase.database().ref('users/').child(userId).child('AuthorityProfile');
    AuthorityRef.update({
      croppedImg: this.state.croppedImg ? this.state.croppedImg : null,
      FBGroup: this.state.FBGroup ? this.state.FBGroup : null,
      webSite: this.state.webSite ? this.state.webSite : null,
      selfIntroduction: this.state.selfIntroduction ? this.state.selfIntroduction : null,
      name: this.state.name ? this.state.name : null,
      userId: userId,
    });
    // var storageRef = firebase.storage().ref('test/').child('test');
    // var message = this.state.croppedImg;
    // storageRef.putString(message, 'base64').then(function(snapshot) {
    //   console.log('Uploaded a base64 string!');
    // });
    const MedicalTeamRef = firebase.database().ref('medicalTeam/').child(userId)
    MedicalTeamRef.update({
      croppedImg: this.state.croppedImg ? this.state.croppedImg : null,
      FBGroup: this.state.FBGroup ? this.state.FBGroup : null,
      webSite: this.state.webSite ? this.state.webSite : null,
      userId: userId,
      name: this.state.name,
      selfIntroduction: this.state.selfIntroduction ? this.state.selfIntroduction : null,
      youCanDo: 'yes'
    });
    this.setState({canReload: true})
    event.preventDefault()
  }
  handlePushTo() {
    var userId = firebase.auth().currentUser.uid
     window.location = ('/MedicalTeams/' + userId )
  }
  handleCancelPushTo() {
    window.location = ('/UserProfile/AuthorityDashbord')
  }
  handleChangeSelfIntroduction(value) {
    this.setState({selfIntroduction: value});
  }
  handleChangeName(event) {
    this.setState({name: event.target.value});
  }
  handleChangeFBGroup(event) {
    this.setState({FBGroup: event.target.value});
  }
  handleChangeWebSite(event) {
    this.setState({webSite: event.target.value});
  }
  render() {
    const modules = {
      toolbar: [
        [{ 'header': [1, 2, false] }],
        ['bold', 'italic'],
        [{'list': 'ordered'}, {'list': 'bullet'}],
        ['clean']
      ],
    }
    const formats = [
      'header',
      'bold', 'italic','list'
    ]
    return(
      <article className="Box">
        <MetaTags>
            <title>草學藥事 || AuthorityDashbord</title>
            <meta id="og-title" property="og:title" content="AuthorityDashbord" />
        </MetaTags>
        <h3>{this.state.Authority}專欄資料</h3>
          <form onSubmit={this.handleSave} >
          <div className="group" style={{marginTop: 30}}>
              <label htmlFor="name">暱稱:</label>
              <input type="text" id="name" value={this.state.name} onChange={this.handleChangeName} style={{width: 300}} placeholder="請輸入您的暱稱" />
          </div>
          <div className="group listPhoto" >
        <div className="avatar-photo">
        <img src={this.state.croppedImg} alt="大頭照" style={{display: this.state.croppedImg ? 'block' : 'none'}} />
          <label htmlFor="listPhoto" >變更大頭照:<small style={{color: 'rgb(255, 60, 120)'}}>*圖片大小200kb以內</small></label>
          <FileUpload handleFileChange={this.handleFileChange} />
          <div className="avatar-edit">
            <i className="fa fa-camera"></i>
          </div>
          
        </div>
        {this.state.cropperOpen &&
          <AvatarCropper
            onRequestHide={this.handleRequestHide}
            cropperOpen={this.state.cropperOpen}
            onCrop={this.handleCrop}
            image={this.state.img}
            width={400}
            height={400}
          />
        }
      </div>
      <div className="lightBox" style={{display: this.state.canReload ? 'flex' : 'none'}}>
              <form className="reportBox">
               <p>已經儲存並發佈了,謝謝</p>
               <span className="btnDefault" onClick={this.handlePushTo}>前往前台專欄頁</span>
               <span className="btnDefault" onClick={this.handleCancelPushTo}>取消</span>
              </form>
             </div>

          <div className="listInfo" >
            <label>自我介紹:</label>
            <ReactQuill value={this.state.selfIntroduction}
              onChange={this.handleChangeSelfIntroduction}
              modules={modules}
              formats={formats}
              style={Jeyu.editor}
              />

            <div className="group" style={{marginTop: 30}}>
              <label htmlFor="FBGroup">FB粉絲團:</label>
              <input type="text" id="FBGroup" value={this.state.FBGroup} onChange={this.handleChangeFBGroup} style={{width: 300}} placeholder="請輸入您的FB粉絲團" />
            </div>
            <div className="group" style={{marginTop: 30}}>
              <label htmlFor="webSite">網站或部落格:</label>
              <input type="text" id="webSite" value={this.state.webSite} onChange={this.handleChangeWebSite} style={{width: 300}} placeholder="請輸入您的網站或部落格" />
            </div>
          </div>
           <small style={{color: 'rgb(255, 60, 120)'}}>*請再一次確認您的資訊喔! 儲存之後將會將您的資訊發佈到網站 同時也正式開通健康達人權限</small><br />
           <input type="submit" value="儲存並發佈到平台" className="btnDefault" />
           <Link to={'/MedicalTeams/' + this.state.userId} style={{display: this.state.name ? 'inline-block' : 'none'}} className="btnDefault"  >前往前台專欄頁</Link>
          </form>
      </article>
    )
  }
}

class FileUpload extends Component {
  constructor() {
    super();
    this.handleFile = this.handleFile.bind(this)
  }
  handleFile(e) {
    var reader = new FileReader();
    var file = e.target.files[0];

    if (!file) return;

    reader.onload = function(img) {
      ReactDom.findDOMNode(this.refs.in).value = '';
      this.props.handleFileChange(img.target.result);
    }.bind(this);
    reader.readAsDataURL(file);
  }
  render() {
     return(
      <input ref="in" type="file" accept="image/*" onChange={this.handleFile} />  
     )
  }
}

const Jeyu = {
  editor: {
    background: '#fff'
  }
}


// WEBPACK FOOTER //
// ./src/View/AuthorityDashbord.js